import React from 'react';

const ChevronsLeftIcon = () => {
	return (
		<svg
			data-testid='chevrons-left'
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<g
				clipPath='url(#clip0_22462_24013)'
			>
				<path
					d='M9.16667 5.83337L5 10L9.16667 14.1667'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M14.1667 5.83337L10 10L14.1667 14.1667'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath
					id='clip0_22462_24013'
				>
					<rect
						fill='white'
						height='20'
						width='20'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default ChevronsLeftIcon;
